// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\---ui-components-src---MechanicInput-module__root {\n  font-size: var(--mechanic-input-font-size);\n}\n", "",{"version":3,"sources":["webpack://./../ui-components/src/MechanicInput.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C","sourcesContent":[".root {\n  font-size: var(--mechanic-input-font-size);\n}\n"],"sourceRoot":""}]);
// Exports
export var root = "---ui-components-src---MechanicInput-module__root";
export default ___CSS_LOADER_EXPORT___;
